// Kept apart from the test data keys so it survives resetTestData
const ACCESS_ORIGIN_KEY = 'accessOrigin'

export const markDemoAccess = () =>
  sessionStorage.setItem(ACCESS_ORIGIN_KEY, 'demo')

export const isDemoAccess = () =>
  sessionStorage.getItem(ACCESS_ORIGIN_KEY) === 'demo'
